import PropTypes from 'prop-types';
import React from 'react';
import { getPdfUrl, getConsentStatusValue, getConsentStatusDisplay, getConsentDateDisplay, shouldDisplay } from '../utils';
import { getCoreUrl } from '../../../config/api';
import { CONSENT_STATUS_REJECTED } from '../constants';
var ConsentFinalized = function ConsentFinalized(_ref) {
  var contact = _ref.contact,
    consentContactEnums = _ref.consentContactEnums;
  var consentStatus = getConsentStatusValue(contact);
  var displayText = getConsentStatusDisplay(consentStatus, consentContactEnums);
  var hiddenClass = shouldDisplay(consentStatus) ? '' : 'consent-finalized__declined';
  var consentIsDeclined = consentStatus === CONSENT_STATUS_REJECTED;
  return /*#__PURE__*/React.createElement("div", {
    className: "consent-finalized col-xs-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "profile-value consent-finalized__status"
  }, displayText)), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-9 ".concat(hiddenClass)
  }, consentIsDeclined ? null : /*#__PURE__*/React.createElement("p", {
    className: "profile-value"
  }, /*#__PURE__*/React.createElement("a", {
    href: getPdfUrl(contact, getCoreUrl()),
    target: "_blank",
    rel: "noreferrer noopener",
    "aria-label": "download consent record"
  }, "Download Record")))), /*#__PURE__*/React.createElement("div", {
    className: "row ".concat(hiddenClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "sub-header"
  }, getConsentDateDisplay(contact, consentStatus)))));
};
ConsentFinalized.propTypes = {
  contact: PropTypes.shape({
    consent: PropTypes.shape({
      response: PropTypes.shape({
        created_at: PropTypes.number
      }),
      request: PropTypes.shape({
        created_by: PropTypes.shape({
          full_name: PropTypes.string
        }),
        request_type: PropTypes.string,
        sent_to: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      })
    })
  }).isRequired,
  consentContactEnums: PropTypes.array.isRequired
};
export default ConsentFinalized;
//# sourceMappingURL=ConsentFinalized.js.map